import React from 'react';
import PhoneInput from 'react-phone-input-2';

import 'react-phone-input-2/lib/style.css';

const locale = navigator.language;
let defaultCountry = '';

const BobPhoneInput = (
    {
        width,
        ...props
    }
) => {
    defaultCountry = locale && locale.includes('en_AU') ? 'au' : 'us';

    return (
        <React.Fragment>
            <PhoneInput
                inputStyle={{
                    width:        '100%',
                    outline:      'none',
                    border:       'none',
                    borderBottom: '1px solid black',
                    borderRadius: 0,
                    paddingTop:   15,
                    paddingLeft:  42,
                    fontSize:     '.8rem !important'
                }}
                buttonStyle={{
                    border:          'none',
                    backgroundColor: '#fff',
                    borderBottom:    '1px solid black',
                    borderRadius:    0,
                    paddingTop:      11
                }}
                country={defaultCountry}
                countryCodeEditable={false}
                copyNumbersOnly={true}
                {...props}
            />
        </React.Fragment>
    );
};

export default BobPhoneInput;
